import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	"aria-hidden": "true",
	focusable: "false",
	"data-prefix": "fas",
	"data-icon": "info-square",
	role: "img",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 448 512",
	className: "svg-inline--fa fa-info-square fa-w-14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-176 86c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z",
		className: ""
	})
});
export default SvgInfoSquare;
